import { Link, useRouteError } from 'react-router-dom';
import './NotFound.scss';

export default function NotFound() {
  const error = useRouteError();
  const message = error?.statusText || error?.message;

  return (
    <div className="not-found">
      <div className="not-found__content">
        <h1>404</h1>
        <p>{message || 'Page not found'}</p>
        <Link to="/" className="not-found__link">Go to homepage</Link>
      </div>
    </div>
  );
}
